import { TableColumn } from "./data-grid.model";
import { SupportSessionAttributes } from "./supportSession.model";

export interface SupportSpecialty {
    id: number;
    name: string;
    slug: string;
    description?: string | null;
    isActive: boolean;
}

export enum SupportSessionStatus {
    Queued = "QUEUED",
    Active = "ACTIVE",
    Closed = "CLOSED",
    Cancelled = "CANCELLED",
}

export enum SpecialistStatus {
    Offline = "OFFLINE",
    Available = "AVAILABLE",
    Busy = "BUSY",
}

export interface SupportSpecialistSummary {
    id: number;
    name: string;
    email: string;
    avatarUrl?: string | null;
    status: SpecialistStatus;
}

export enum SenderType {
    User = "user",
    Specialist = "specialist",
    System = "system",
    Assistant = "assistant",
}

export interface SupportMessage {
    id: number;
    sessionId: number;
    senderType: SenderType;
    body: string;
    createdAt: string;
    metadata?: {
        isAiHistory?: boolean;
        originalSender?: string;
        [key: string]: any;
    };
}

export interface StartSessionResponse {
    session: SupportSessionAttributes;
    specialist?: SupportSpecialistSummary | null;
    queued: boolean;
}

export const ChatHistoryListColumns: TableColumn[] = [
    { key: "userDisplayName", value: "User Name", type: "text" },
    { key: "contactPhone", value: "User Phone Number", type: "text" },
    { key: "contactEmail", value: "User Email", type: "text" },
    { key: "status", value: "Status", type: "text" },
    { key: "messages", value: "Chat History", type: "button" },
];
